// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__rtNeI","LogoContainer":"Layout_LogoContainer__V3l+R","Container":"Layout_Container__jya5N"};